export const config = {
  apiKey: "AIzaSyB_iGIH3tWKMl5psEzYfmZKe7IqkfhpC7Q",
  authDomain: "tma1-products-qa.firebaseapp.com",
  databaseURL: "https://tma1-products-qa.firebaseio.com",
  storageBucket: "tma1-products-qa.appspot.com",
  messagingSenderId: "905292205669",
  appId: "1:905292205669:web:a6431322ba76cc54d3008c",
  measurementId: "G-V3YMS8XY0C",

  // change the project for the emulator.
  projectId: "cavs-local-dev",
};

export const shouldUseEmulator = true;
